import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { Filter } from 'src/redux/productsQuery/types/Filter';
import { getFiltersWithSortFilter } from '../helpers/getFiltersWithSortFilter';

export const selectFilterByUid = (state: ReduxApplicationState, uid: string): Filter | null => {
  return state.productsQuery.filters.find((filter) => filter.uid === uid) || null;
};

export const selectFiltersWithSortFilter = (state: ReduxApplicationState) => {
  return getFiltersWithSortFilter(state.productsQuery.filters, state.productsQuery.sortOptions);
};

export const selectTotalActiveOptions = (state: ReduxApplicationState) => {
  return state.productsQuery.filters.reduce((total, filter) => {
    const activeOptionsCount = filter.options.filter((option) => option.active).length;

    total = total + activeOptionsCount;

    return total;
  }, 0);
};

export const selectAppliedFilterIDs = (state: ReduxApplicationState) => {
  return state.productsQuery.filters
    .filter((filter) => filter.options.some((option) => option.active))
    .map((filter) => filter.uid);
};

export const selectUserAppliedFilterTitles = (state: ReduxApplicationState) => {
  const appliedFilterTitles = state.productsQuery.filters.reduce((acc: string[], filter) => {
    const filterIsApplied = filter.options.some((option) => option.active);

    if (filterIsApplied) {
      acc.push(filter.title);
    }

    return acc;
  }, []);

  return appliedFilterTitles.join(', ');
};

export const selectActiveSortOption = (state: ReduxApplicationState) => {
  return state.productsQuery.sortOptions.find((option) => option.active) || null;
};
